import { render, staticRenderFns } from "./visitMain.vue?vue&type=template&id=0b198653&scoped=true&"
import script from "./visitMain.vue?vue&type=script&lang=js&"
export * from "./visitMain.vue?vue&type=script&lang=js&"
import style0 from "./visitMain.vue?vue&type=style&index=0&id=0b198653&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b198653",
  null
  
)

export default component.exports